import "./LoadingSpinner.scss";

import React, { useContext } from "react";
import clsx from "clsx";

import { VisibleContext } from "../../../lib/util/ReactUtils";
// Splitting into 2 parts for IE11 animation
import { IconSpinner, IconSpinnerB } from "../../../assets";

export interface LoadingSpinnerProps {
	visible?: boolean;
	className?: string;
}

const LoadingSpinner = (props: LoadingSpinnerProps) => {
	let { visible, className } = props;

	if (visible === undefined) {
		visible = true;
	}

	const visibleContextState = useContext(VisibleContext);

	return (
		<div
			className={clsx(
				"LoadingSpinner__container",
				visible && visibleContextState && "--visible",
			)}
		>
			<IconSpinner className={clsx("LoadingSpinner", className)} />
			<IconSpinnerB className={clsx("LoadingSpinner__static", className)} />
		</div>
	);
};

export default React.memo(LoadingSpinner);
